module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"followedBy":"Followed by","watchersPlaceholder":"Add users.."},"fr":{"followedBy":"Suivi par","watchersPlaceholder":"Ajouter utilisateurs..."},"de":{"followedBy":"gefolgt von","watchersPlaceholder":"Benutzer hinzufügen..."}}')
  delete Component.options._Ctor
}
